import createAuthContext from './createAuthContext'
import type Keycloak from 'keycloak-js'

export const reactKeycloakWebContext = createAuthContext<Keycloak>()

export const ReactKeycloakWebContextConsumer = reactKeycloakWebContext.Consumer
